"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.content = exports.overlay = exports.image = exports.avatar = void 0;

var _util = require("../../../util");

const avatar = ({
  theme,
  cssProps
}) => {
  const {
    avatars
  } = theme;
  const {
    size = 'medium'
  } = cssProps;
  const renderedSize = avatars[size];
  return {
    background: (0, _util.color)(theme, 'background.gold'),
    borderRadius: avatars.borderRadius,
    height: renderedSize,
    overflow: 'hidden',
    position: 'relative',
    width: renderedSize,
    '&:hover [data-overlay]': {
      background: (0, _util.color)(theme, avatars.overlayHover)
    },
    '&:active [data-overlay]': {
      background: (0, _util.color)(theme, avatars.overlayActive)
    }
  };
};

exports.avatar = avatar;

const image = () => ({
  height: '100%',
  objectFit: 'cover',
  width: '100%'
});

exports.image = image;

const overlay = () => ({
  background: 'transparent',
  height: '100%',
  position: 'absolute',
  transition: 'background 0.2s ease',
  width: '100%'
});

exports.overlay = overlay;

const content = () => ({
  position: 'relative'
});

exports.content = content;
//# sourceMappingURL=Avatar.style.js.map